module.exports = __webpack_public_path__ + "img/Demjan.1fc65a45.jpg";